import ServiceDetails from "./ServiceDetails";
import PageBreadcrumbs from "./../SharedComponent/page-breadcrumbs";
import { SERVICES } from "./../constant/services";
import React, { useEffect, useLayoutEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const ServiceDetailsPage = () => {
  const { slug } = useParams();
  const SERVICE = SERVICES.find((item) => item.slug === slug);
  const topRef = useRef(null);
  useLayoutEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [slug]);
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(SERVICE);
    console.log(slug);
  }, []);

  if (!SERVICE) return <div>Service not found.</div>;
  return (
    <>
     <div ref={topRef}></div>
      <PageBreadcrumbs
        title={SERVICE.title}
        subtitle="Service Details"
        breadcrumbs={{
          currentPage: SERVICE.title,
          items: [{ name: "Services", href: "/services" }],
        }}
      />
      <ServiceDetails {...SERVICE} />
    </>
  );
};

export default ServiceDetailsPage; 